import { ClientDeviceType } from '@/types/cml-api'

export function deviceTypeClassGenerator(deviceTypes: string) {
    const isMobileDevice = deviceTypes.includes(ClientDeviceType.Mobile)
    const isDesktopDevice = deviceTypes.includes(ClientDeviceType.Desktop)

    if (isMobileDevice && isDesktopDevice) return ''
    else if (isMobileDevice) return 'lg:hidden'
    else if (isDesktopDevice) return 'lg:flex hidden'
    else return ''
}
